import type { ConceptDef } from '../types';

export const wordBuild: ConceptDef = {
  kind: 'sequenceTap',
  id: 'word-build',
  label: 'Word Build',
  category: 'Literacy',
  description: 'Tap letters in order to spell a word.',
  config: {
    promptMode: 'AUDIO',
    sequences: [
      { label: 'Spell CAT.', items: ['C', 'A', 'T'] },
      { label: 'Spell DOG.', items: ['D', 'O', 'G'] },
      { label: 'Spell SUN.', items: ['S', 'U', 'N'] },
      { label: 'Spell PIG.', items: ['P', 'I', 'G'] },
      { label: 'Spell HEN.', items: ['H', 'E', 'N'] },
    ],
  },
};
